import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=febc13c2&"
import script from "./PublicLayout.vue?vue&type=script&lang=js&"
export * from "./PublicLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports